export const containerClassName = (theme = {})=>{
    return theme['galleryPlugin'];
};

//# sourceMappingURL=classNameStrategies.js.map